import axios from 'axios';
import { isDefined, attachCategoryToMenuItems } from './utils';
import { getConfig } from '../appConfig';
import { Capacitor } from '@capacitor/core';
import { App as AppCap } from '@capacitor/app';
import packageInfo from '../../package.json';

let axiosInstance;

const baseURL = getConfig().api.baseURL;
const wordPressBaseURL = getConfig().api.wordPressBaseURL;
const nativeWallet = getConfig().api.nativeWallet;
const addToGoogleWallet = `${nativeWallet}/google-wallet`;
const addToAppleWallet = `${nativeWallet}/apple-wallet`;
const endpoints = {
  login: '/api-token-auth', //post
  register: '/me/register', //post
  getProfile: '/me', //get
  changePassword: '/me', //put
  changeProfile: '/me', //put
  resetPassword: '/me/reset_password', //put
  deleteCard: '/delete_payment_card', //put
  sendFeedback: '/feedback/create', //post,
  firebaseToken: '/firebase-token', //post,
  appVersion: '/appversion', //get,
  social: '/social', //get,
  restaurants: '/restaurants/all', //get
  terms: '/terms', //get,
  privacyPolicy: '/privacy', //get
  faq: '/faq', //get
  rewards: '/reward_milestones', //get
  history: '/transactions/history', //get
  ikentooMenu: '/ikentoo_menu/', //get
  ikentooMenusForLocation: '/ikentoo_menus/', //get
  curatedMenus: '/curated_menus', //get
  curatedMenu: '/curated_menu/', //get
  getPaymentCards: '/orders/list_payment_cards', //post
  addPaymentCard: '/orders/create_payment_card', //post
  removePaymentCard: '/orders/delete_payment_card', //post
  createOrder: '/order/create', //post
  orderHistory: '/me/orders', //get
  validateEmail: '/me/validate_email', //get
  sendVoucherCode: '/voucher/code', //put,
  referFriend: '/referred/add_friend', //post
  getVouchers: '/me/vouchers', //get
  publicStripeKey: '/public_stripe_key', //get
  frontEndAppConfig: '/front_end_app_config', //get
  getTranslations: '/translation_json', //get
  addDeliveryAdress: '/me/add_new_address', //put
  getRestaurantSnoozeData: '/ikentoo_menu/get_snooze_data', //get
  postCodeCheck: '/order/postcode_check', //post
  getNearestLocation: '/order/get_nearest_restaurant_location', //put
  getDeliveryRangeType: '/get_delivery_range_type', //get
  locationCodeCheck: '/order/location_code_check', // post
  addPickupPoint: '/me/add_pickup_point', // put,
  getOrderProduction: '/order_production_length',
  removeDeliveryAddress: '/orders/remove_delivery_address', //post
  cancelOrder: '/orders/cancel_order', // post
  getDefaultMenuId: '/get_default_menu_id', //get
  getDefaultMenu: '/get_default_menu', //get
  saveJudoPayCard: '/orders/save_judo_pay_cards', //post
  checkDiscount: '/order/check_discount', //post
  checkMultiBasketDiscount: '/order/check_multibasket_discount',
  checkDiscountWithTaxes: '/order/check_tax_discount', //post
  checkMultiBasketDiscountWithTaxes: '/order/check_tax_multibasket_discount',
  voucherDiscount: '/order/get_voucher_discount', //post
  getLastOrder: '/orders/get_last_order', // get
  paymentInfo: '/update_payment_info',
  subscriptionPackages: '/subscription/packages', // get
  createSubscription: '/subscription/create_stripe_subscription', // post
  createSubscriptionNative: '/subscription/create_stripe_subscriptio_native', // post
  cancelSubscription: '/subscription/cancel', // put
  addSubscriptionRestaurant: '/subscriptions/add_home_location',
  payMembership: '/subscription/memberships', // post
  sendGiftVoucher: '/gift_voucher/create',
  resendGiftVoucher: '/gift_voucher/resend',
  redeemGiftVoucher: '/gift_voucher/redeem_code',
  getSentGiftVouchers: '/gift_voucher/sent_gift_vouchers',
  updateGiftVoucher: '/gift_voucher/update',
  checkGiftVoucherBalance: '/gift_voucher/check_balance',
  getNews: '/news',
  nutritionData: '/nutrition_data',
  client: '/client', //get,
  createPrebuildPaymentOrder: '/order/create_prebuild_payment_order', //post
  updateStripeOrder: '/order/update_stripe_order', //post
  removeProfile: '/me/delete_user', // post
  createStripeOrderNative: '/order/create_stripe_order_native',
  confirmPaymentIntentNative: '/order/confirm_payment_intent_native',
  updateProfileImage: '/me/update_profile_image',
  createYocoOrder: '/order/create_yoco_order', //post
  buyReward: '/reward/buy',
  butAtreemoReward: '/reward/buy-atreemo-offer',
  refreshScanToken: '/refresh_scan_token',
  getMultiVenueOrder: '/me/multi_basket_order',
  getTax: '/order/get_tax_breakdown',
  getTaxData: '/order/get_tax',
  bookDriver: '/order/prebook_delivery',
  bookUberDriver: '/order/uber/prebook_delivery',
  getGiftCards: '/me/gift_cards',
  floorPlans: '/floor_plans/', //get
  checkTables: '/check_table/', //get
  setTablePayMethod: '/set_pay_method/', //put
  getTableById: '/get_table_by_id/', //get
  payTable: '/create_table_order/', //post
  selectTableItem: '/update_selected_items/',
  sendTablePaymentEmail: '/send_table_payment_email/',
  loyaltyInfo: '/loyalty_info',
  unlockRewardsInfo: '/unlock_rewards_info',
  milestoneRewardsInfo: '/milestone_rewards_info',
  allergens: '/allergens', //get
  refreshToken: '/api-token-refresh',
  checkOrderItems: '/order/multivenue_items_check',
  removeRedemtionsFromVouchers: '/order/remove_redemtions_from_vouchers',
  createSquareOrder: '/order/create_square_order', //post,
  getOrderByUuid: '/order/get_by_uuid', // get
  createSquarePaymentCard: '/orders/create_square_payment_card', //post,
  createCheckoutOrderNative: '/order/create_checkout_order_native', //post,
  updateCheckoutOrder: '/order/update_checkout_order', //post,
  createSquareSubscription: '/subscription/create_square_subscription', // post
  getGameVoucherPreview: '/game_campaigns/preview',
  setGameVoucherSpin: '/game_campaigns/spin',
  releaseVoucher: '/order/release_voucher',
  sendGiftVoucherCode: '/gift_card/check_printed_code ', //put,
  getNotifications: '/me/notifications', // get
  readNotifications: '/me/read_notification',
  deleteNotification: '/me/delete_notification',
  getBasketUpsells: '/get_basket_upsells',
  getImagesFromMenus: '/ikentoo_menus/get_product_images', //get,
  getTopProducts: '/get_top_selling_products',
  events: '/events', //get
  eventCategories: '/events/categories', //get
  event: '/events/', //get
  myEvents: '/events/my', //get
  eventTicket: '/events/tickets/', //get
  eventPurchase: '/events/purchase', //post

};

const createAxiosInstance = (token) => {
  const headers = isDefined(token)
    ? {
      Authorization: 'JWT ' + token,
    }
    : {};
  axiosInstance = axios.create({
    headers,
    timeout: 50000,
  });
  return axiosInstance;
};

export const isAuthorizationTokenSet = () => {
  if (axiosInstance && axiosInstance.defaults && axiosInstance.defaults.headers) {
    const authHeader = axiosInstance.defaults.headers['Authorization'] || axiosInstance.defaults.headers.common['Authorization'];
    return !!authHeader;
  }
  return false;
};

export const isFieldValid = (fieldName, errors = {}) => !isDefined(errors[fieldName]);

export const getErrorMessage = (fieldName, errors = {}) =>
  !isFieldValid(fieldName, errors) ? errors[fieldName] : '';

const getClientId = async () => {
  let clientId = null;
  if (Capacitor.isNativePlatform()) {
    const info = await AppCap.getInfo();
    const appVersionFromDevice = info.version;
    clientId = parseInt(appVersionFromDevice.split('.')[0]);
  }
  return clientId;
};
const api = {
  getTranslations: async () => {
    const response = await createAxiosInstance().get(
      `${wordPressBaseURL}/en/dictionary/${getConfig().envs.APP_DOMAIN}`
    )
    return response.data
  },
  login: async (username, password, socialAuth) => {
    const response = await createAxiosInstance().post(
      baseURL +
      `${endpoints.login}${Capacitor.isNativePlatform() ? `?isWeb=true` : ''
      }`,
      {
        username,
        password,
        socialAuth,
        client_id: await getClientId(),
        version: packageInfo.version,
      },
    );
    axiosInstance = createAxiosInstance(response.data.token);
    return response;
  },
  register: async (userData) => {
    userData.client_id = await getClientId();
    const response = await createAxiosInstance().post(
      baseURL +
      `${endpoints.register}${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`,
      { ...userData, version: packageInfo.version }
    );
    axiosInstance = createAxiosInstance(response.data.token);
    return response;
  },
  logout: () => {
    console.log('logout');
  },
  resetPassword: async (email) =>
    await axiosInstance.put(baseURL + endpoints.resetPassword + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      email,
      client_id: await getClientId(),
      version: packageInfo.version,
    }),
  getProfile: async () =>
    await axiosInstance.get(
      baseURL +
      endpoints.getProfile +
      `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
    ),
  updateProfile: async (data = {}) =>
    await axiosInstance.put(baseURL + endpoints.changeProfile + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      client_id: await getClientId(),
      version: packageInfo.version,
    }),
  sendFirebaseToken: async (data) =>
    await axiosInstance.post(baseURL + endpoints.firebaseToken + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      client_id: await getClientId(),
      version: packageInfo.version,
    }),
  getAppVersion: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.appVersion}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data.data?.min_front_end_version),
  getSocialLinks: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.social}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data.social_link_json),
  sendFeedback: async (data = {}) =>
    await axiosInstance.post(baseURL + endpoints.sendFeedback + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  getRestaurants: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.restaurants}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  getTerms: async (locale, client_name) =>
    axios
      .create()
      .get(baseURL + '/' + locale + '/terms/' + client_name + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,)
      .then((res) => res.data),
  getPrivacyPolicy: async (locale, client_name) =>
    axios
      .create()
      .get(baseURL + '/' + locale + '/privacy/' + client_name + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`)
      .then((res) => res.data),
  getFaq: async (locale, client_name) =>
    axios
      .create()
      .get(baseURL + '/' + locale + '/faqs/' + client_name + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`)
      .then((res) => res.data),


  getRewards: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.rewards}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  getIkenooMenu: async (menuId, businessLocationId, orderType) =>
    axiosInstance
      .get(
        baseURL +
        endpoints.ikentooMenu +
        menuId +
        '/location/' +
        businessLocationId +
        (orderType ? '/' + orderType : '') +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => attachCategoryToMenuItems(res.data.data)),
  getCuratedMenus: async () =>
    axiosInstance
      .get(
        baseURL +
        endpoints.curatedMenus +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  getCuratedMenu: async (menuId, orderType) =>
    axiosInstance
      .get(
        baseURL +
        endpoints.curatedMenu +
        menuId +
        (orderType ? '/' + orderType : '') +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => {
        const curatedMenu = res.data.data || {};
        return { ...curatedMenu, items: (curatedMenu.items || []).map(attachCategoryToMenuItems) };
      }),
  getIkentooMenusForLocation: async (businessLocationId) =>
    axiosInstance
      .get(
        baseURL +
        endpoints.ikentooMenusForLocation +
        'location/' +
        businessLocationId +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  getHistory: async (page) =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.history}${page ? `/${page}` : ''}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data),
  getPaymentCards: async () =>
    axiosInstance
      .post(
        baseURL +
        endpoints.getPaymentCards +
        `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`,
        {
          client_id: await getClientId(),
          version: packageInfo.version,
        }
      )
      .then((res) => res.data.data),
  addPaymentCard: async (cardData) =>
    axiosInstance
      .post(baseURL + endpoints.addPaymentCard + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...cardData, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data.data),
  removePaymentCard: async (cardData) =>
    axiosInstance
      .post(baseURL + endpoints.removePaymentCard + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...cardData, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  createOrder: async (orderData) =>
    axiosInstance
      .post(baseURL + endpoints.createOrder + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...orderData, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  getOrderHistory: async (page) =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.orderHistory}${page ? `/${page}` : ''}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data),
  sendCode: async (data) =>
    axiosInstance
      .put(baseURL + endpoints.sendVoucherCode + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  sendRefer: async (data) =>
    axiosInstance
      .post(baseURL + endpoints.referFriend + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  getVouchers: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.getVouchers}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data),
  validateEmail: async () =>
    await axiosInstance.get(
      baseURL +
      `${endpoints.validateEmail}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
      }`,
    ),
  getPublicStripeKey: async () =>
    axiosInstance
      .get(
        baseURL +
        endpoints.publicStripeKey +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data.public_stripe_key),
  getFrontEndAppConfig: async () => {
    if (!axiosInstance) {
      await createAxiosInstance();
    }
    return axiosInstance
      .get(
        baseURL +
        `${endpoints.frontEndAppConfig}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data.data);
  },
  getClient: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.client}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data.data),
  addDeliveryAdress: async (data) =>
    axiosInstance.put(baseURL + endpoints.addDeliveryAdress + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  getRestaurantSnoozeData: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.getRestaurantSnoozeData}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data.data),
  postCodeCheck: async (data) =>
    axiosInstance.post(baseURL + endpoints.postCodeCheck + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  getNearestLocation: async (data) =>
    axiosInstance.put(baseURL + endpoints.getNearestLocation + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  getDeliveryRangeType: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.getDeliveryRangeType}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data.data.delivery_range_type),
  locationCodeCheck: async (data) =>
    axiosInstance.post(baseURL + endpoints.locationCodeCheck + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  addPickupPoint: async (data) =>
    axiosInstance.put(baseURL + endpoints.addPickupPoint + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  getOrderProduction: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.getOrderProduction}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data.data.order_production_mins),
  removeDeliveryAddress: async (postalCode) =>
    axiosInstance
      .post(baseURL + endpoints.removeDeliveryAddress + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
        ...postalCode,
        version: packageInfo.version,
        client_id: await getClientId(),
      })
      .then((res) => res.data),
  cancelOrder: async (data) =>
    axiosInstance
      .post(baseURL + endpoints.cancelOrder + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data.data),
  getDefaultMenuId: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.getDefaultMenuId}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''
        }`,
      )
      .then((res) => res.data.data.default_menu_id),
  getDefaultMenu: async (menuId) =>
    axiosInstance
      .get(
        baseURL +
        endpoints.getDefaultMenu +
        '/' +
        menuId +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => attachCategoryToMenuItems(res.data.data)),
  saveJudoPayCard: async (cardData) =>
    axiosInstance
      .post(baseURL + endpoints.saveJudoPayCard + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...cardData, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data.data),
  voucherDiscount: async (data) =>
    await axiosInstance.post(baseURL + endpoints.voucherDiscount + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  checkDiscount: async (data) =>
    await axiosInstance.post(baseURL + endpoints.checkDiscount + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  checkMultiBasketDiscount: async (data) =>
    await axiosInstance.post(baseURL + endpoints.checkMultiBasketDiscount + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  checkDiscountWithTaxes: async (data) =>
    await axiosInstance.post(baseURL + endpoints.checkDiscountWithTaxes + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  checkMultiBasketDiscountWithTaxes: async (data) =>
    await axiosInstance.post(baseURL + endpoints.checkMultiBasketDiscountWithTaxes + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  getOrderByUuid: async (uuid) =>
    axiosInstance
      .get(
        baseURL +
        endpoints.getOrderByUuid +
        `?uuid=${encodeURIComponent(uuid)}&version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  getLastOrder: async (id) =>
    axiosInstance
      .get(
        baseURL +
        endpoints.getLastOrder +
        '/' +
        id +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  updatePaymentInfo: async (paymentInfo = {}) =>
    axiosInstance
      .post(baseURL + endpoints.paymentInfo + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...paymentInfo, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data.data),
  getSubscriptions: async () =>
    await axiosInstance.get(
      baseURL +
      endpoints.subscriptionPackages +
      `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
    ),
  createSubscription: async (data) =>
    await axiosInstance.post(baseURL + endpoints.createSubscription + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  createSubscriptionNative: async (data) =>
    await axiosInstance.post(baseURL + endpoints.createSubscriptionNative + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  cancelUserSubscription: async (data) =>
    axiosInstance.put(baseURL + endpoints.cancelSubscription + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),

  payMembership: async (membership) =>
    axiosInstance.post(baseURL + endpoints.payMembership + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...membership,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  sendGiftVoucher: async (data) =>
    axiosInstance
      .post(baseURL + endpoints.sendGiftVoucher + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  resendGiftVoucher: async (data) =>
    axiosInstance
      .put(baseURL + endpoints.resendGiftVoucher + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  updateGiftVoucher: async (data) =>
    axiosInstance
      .put(baseURL + endpoints.updateGiftVoucher + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  redeemGiftVoucher: async (data) =>
    axiosInstance
      .post(baseURL + endpoints.redeemGiftVoucher + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  getSentGiftVouchers: async () =>
    axiosInstance
      .get(
        baseURL +
        endpoints.getSentGiftVouchers +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data),


  checkGiftVoucherBalance: async (data) => {
    return axiosInstance.post(baseURL + endpoints.checkGiftVoucherBalance + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data);
  },
  getNews: async () =>
    axiosInstance
      .get(
        baseURL +
        endpoints.getNews +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data),
  getNutritonData: async () =>
    axiosInstance
      .get(
        baseURL +
        endpoints.nutritionData +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  addToGoogleWallet: async (data) =>
    axiosInstance
      .post(addToGoogleWallet + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, appversion: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  addToAppleWallet: async (data) =>
    axiosInstance
      .post(addToAppleWallet + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, appversion: packageInfo.version, client_id: await getClientId() }, { responseType: 'blob' })
      .then((res) => res.data),
  createPrebuildPaymentOrder: async (orderData) => axiosInstance.post(baseURL + endpoints.createPrebuildPaymentOrder + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...orderData, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data),
  updateStripeOrder: async (orderId) => axiosInstance.post(baseURL + endpoints.updateStripeOrder + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...orderId, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data),
  removeProfile: async (data) => await axiosInstance.post(baseURL + endpoints.removeProfile + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() }),
  createStripeOrderNative: async (orderData) =>
    axiosInstance
      .post(baseURL + endpoints.createStripeOrderNative + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...orderData, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  confirmPaymentIntentNative: async (data) =>
    axiosInstance
      .post(baseURL + endpoints.confirmPaymentIntentNative + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  updateProfileImage: async (data) => await axiosInstance.post(baseURL + endpoints.updateProfileImage, data),
  createYocoOrder: async (orderData) =>
    axiosInstance
      .post(baseURL + endpoints.createYocoOrder + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...orderData, version: packageInfo.version, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null })
      .then((res) => res.data),
  buyReward: async (rewardId) => axiosInstance.put(`${baseURL}${endpoints.buyReward}/${rewardId}`, { client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data),
  butAtreemoReward: async (data) => axiosInstance.post(`${baseURL}${endpoints.butAtreemoReward}`, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data),

  getUnlockRewardsInfo: async () => axiosInstance.get(baseURL + endpoints.unlockRewardsInfo + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data),
  getMilestoneRewardsInfo: async () => axiosInstance.get(baseURL + endpoints.milestoneRewardsInfo + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data),
  getLoyaltyInfo: async () => axiosInstance.get(baseURL + endpoints.loyaltyInfo + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data),
  refreshScanToken: async () => {
    return axiosInstance.get(baseURL + endpoints.refreshScanToken + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data.data);
  },

  getTax: async (data) => axiosInstance.post(`${baseURL}${endpoints.getTax}${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data),
  getTaxData: async (uuid) => axiosInstance.get(`${baseURL}${endpoints.getTaxData}/${uuid}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data),
  getMultiVenueOrder: async (data) => axiosInstance.post(`${baseURL}${endpoints.getMultiVenueOrder}${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data),
  bookDriver: async (data) => axiosInstance.post(`${baseURL}${endpoints.bookDriver}${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data),
  getGiftCards: async () => axiosInstance.get(baseURL + endpoints.getGiftCards + `${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data),
  getFloorPlans: async (data) => axiosInstance.post(baseURL + endpoints.floorPlans, { business_location_ids: data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data.data),
  getTableData: async (tableNumber, businessLocationId) => {
    return axiosInstance.get(baseURL + endpoints.checkTables + tableNumber + '/' + businessLocationId + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data.data);
  },
  setTablePayMethod: async (data) => {
    return axiosInstance.put(baseURL + endpoints.setTablePayMethod, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data);
  },
  getTableById: async (tableBillId) => {
    return axiosInstance.get(baseURL + endpoints.getTableById + tableBillId + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data.data);
  },
  postSlectItems: async (tableNumber, businessLocationId, data) => {
    return axiosInstance.post(baseURL + endpoints.selectTableItem + tableNumber + '/' + businessLocationId, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data.data);
  },
  payTable: async (data) => {
    return axiosInstance.post(baseURL + endpoints.payTable, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data);
  },
  sendTablePaymentEmail: async (data) => {
    return axiosInstance.post(baseURL + endpoints.sendTablePaymentEmail, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data);
  },
  getAllergensInfo: async (locale, client_name) =>
    axios
      .create()
      .get(wordPressBaseURL + '/' + locale + '/allergen-index/' + client_name + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`, {
        responseType: 'text',
      })
      .then((res) => res.data),
  getAllergens: async () => axiosInstance.get(baseURL + endpoints.allergens + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data),
  refreshToken: async (data) => axiosInstance.post(baseURL + endpoints.refreshToken + `?version=${packageInfo.version}`, data).then((res) => res.data),
  checkOrderItems: async (data) => axiosInstance.post(baseURL + endpoints.checkOrderItems + `?version=${packageInfo.version}`, data).then((res) => res.data.data),
  bookUberDriver: async (data) => axiosInstance.post(`${baseURL}${endpoints.bookUberDriver}${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data),

  addSubscriptionRestaurant: async (data) => axiosInstance.post(`${baseURL}${endpoints.addSubscriptionRestaurant}${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, client_id: await getClientId(), isWeb: Capacitor.isNativePlatform() ? true : null }).then((res) => res.data),
  removeRedemtionsFromVouchers: async () => axiosInstance.get(baseURL + endpoints.removeRedemtionsFromVouchers + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data),
  createSquareOrder: async (orderData) => axiosInstance.post(baseURL + endpoints.createSquareOrder + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...orderData, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data),
  createSquarePaymentCard: async (cardData) => {
    const res = await axiosInstance.post(baseURL + endpoints.createSquarePaymentCard + `${Capacitor.isNativePlatform() ? '?isWeb=true' : ''}`, { ...cardData, version: packageInfo.version, client_id: await getClientId() });
    return res.data.data;
  },
  createCheckoutOrderNative: async (orderData) => axiosInstance.post(baseURL + endpoints.createCheckoutOrderNative + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...orderData, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data),
  updateCheckoutOrder: async (orderId) => axiosInstance.post(baseURL + endpoints.updateCheckoutOrder + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...orderId, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data),
  createSquareSubscription: async (data) =>
    await axiosInstance.post(baseURL + endpoints.createSquareSubscription + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, {
      ...data,
      version: packageInfo.version,
      client_id: await getClientId(),
    }),
  getGameVoucherPreview: async (id) => axiosInstance.get(`${baseURL}${endpoints.getGameVoucherPreview}/${id}` + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data),

  setGameVoucherSpin: async (data) =>
    axiosInstance
      .post(baseURL + endpoints.setGameVoucherSpin + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  releaseVoucher: async (data) =>
    axiosInstance
      .post(baseURL + endpoints.releaseVoucher + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  sendGiftVoucherCode: async (data) =>
    axiosInstance
      .post(baseURL + endpoints.sendGiftVoucherCode + `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`, { ...data, version: packageInfo.version, client_id: await getClientId() })
      .then((res) => res.data),
  getNotifications: async () =>
    axiosInstance.get(baseURL + endpoints.getNotifications + `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`).then((res) => res.data.data),
  readNotifications: async (data) =>
    axiosInstance.post(baseURL + endpoints.getNotifications, { ...data, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data),
  deleteNotification: async (data) =>
    axiosInstance.post(baseURL + endpoints.deleteNotification, { ...data, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data),
  getBasketUpsells: async (data) =>
    axiosInstance.post(baseURL + endpoints.getBasketUpsells, { ...data, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data.data),
  getImagesFromMenus: async (businessLocationId, menu_id) =>
    axiosInstance
      .get(`${baseURL}${endpoints.getImagesFromMenus}/${businessLocationId}/${menu_id}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`)
      .then((res) => res.data.data),
  getTopProducts: async (data) =>
    axiosInstance.post(baseURL + endpoints.getTopProducts, { ...data, version: packageInfo.version, client_id: await getClientId() }).then((res) => res.data.data),
  getEvents: async (filters = {}, page) => {
    const { category, search, featured, tag } = filters;
    const params = new URLSearchParams({ version: packageInfo.version });
    // category accepts an id or a slug, tag accepts an id or a name
    if (isDefined(category)) params.append('category', category);
    if (isDefined(search)) params.append('search', search);
    if (featured) params.append('featured', 'true');
    if (isDefined(tag)) params.append('tag', tag);
    params.append('page', page || 1);
    params.append('page_size', 20);
    if (Capacitor.isNativePlatform()) {
      params.append('isWeb', 'true');
      params.append('client_id', await getClientId());
    }
    return axiosInstance.get(`${baseURL}${endpoints.events}?${params.toString()}`).then((res) => res.data.data);
  },
  getEventCategories: async () =>
    axiosInstance
      .get(
        baseURL +
        `${endpoints.eventCategories}?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  getEvent: async (idOrSlug) =>
    axiosInstance
      .get(
        baseURL +
        endpoints.event +
        idOrSlug +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  getMyEvents: async (type, page) => {
    const params = new URLSearchParams({ version: packageInfo.version });
    if (isDefined(type)) params.append('type', type);
    params.append('page', page || 1);
    params.append('page_size', 20);
    if (Capacitor.isNativePlatform()) {
      params.append('isWeb', 'true');
      params.append('client_id', await getClientId());
    }
    return axiosInstance.get(`${baseURL}${endpoints.myEvents}?${params.toString()}`).then((res) => res.data.data);
  },
  getEventTicket: async (uuid) =>
    axiosInstance
      .get(
        baseURL +
        endpoints.eventTicket +
        uuid +
        `?version=${packageInfo.version}${Capacitor.isNativePlatform() ? `&isWeb=true&client_id=${await getClientId()}` : ''}`,
      )
      .then((res) => res.data.data),
  transferEventTicket: async (uuid, data) =>
    axiosInstance
      .post(
        baseURL +
        endpoints.eventTicket +
        uuid +
        `/transfer${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`,
        { ...data, version: packageInfo.version, client_id: await getClientId() },
      )
      .then((res) => res.data),
  /* data: { event_id, items: [{ tier_id, quantity }], tip } — validates only, takes no payment */
  purchaseEvent: async (data) =>
    axiosInstance
      .post(
        baseURL +
        endpoints.eventPurchase +
        `${Capacitor.isNativePlatform() ? `?isWeb=true` : ''}`,
        { ...data, version: packageInfo.version, client_id: await getClientId() },
      )
      .then((res) => res.data),
};



api.createAxiosInstance = createAxiosInstance;

export default { ...api };
